import Vue from 'vue';
import API from '@/api';
import * as types from '@/store/mutationTypes';

// the status is a map of { String, Boolean }: company ID to loading status
const state = {
  contactsStatus: {},
  contacts: {},
  accountsStatus: {},
  accounts: {},
  salesItemsStatus: {},
  salesItems: {},
};

const getters = {
  contactsStatus: xroState => xroState.contactsStatus,
  contacts: xroState => xroState.contacts,
  accountsStatus: xroState => xroState.accountsStatus,
  accounts: xroState => xroState.accounts,
  salesItemsStatus: xroState => xroState.salesItemsStatus,
  salesItems: xroState => xroState.salesItems,
};

const mutations = {
  [types.SET_XRO_CONTACTS](qbState, qbData) {
    Vue.set(qbState.contacts, qbData.companyId, qbData.contacts);
    Vue.set(qbState.contactsStatus, qbData.companyId, qbData.loading);
  },
  [types.SET_XRO_ACCOUNTS](qbState, qbData) {
    Vue.set(qbState.accounts, qbData.companyId, qbData.accounts);
    Vue.set(qbState.accountsStatus, qbData.companyId, qbData.loading);
  },
  [types.SET_XRO_SALES_ITEMS](qbState, qbData) {
    Vue.set(qbState.salesItems, qbData.companyId, qbData.salesItems);
    Vue.set(qbState.salesItemsStatus, qbData.companyId, qbData.loading);
  },
};


const actions = {
  clear({ commit }) {
    commit(types.CLEAR_QB_MODULE);
  },
  reloadCompanyInfo({ commit, dispatch }, companyId) {
    // here, commit rather than dispatch to ensure completion before loading
    commit(types.CLEAR_QB_COMPANY_MODULE, { companyId });

    dispatch('getXeroContacts', companyId);
    dispatch('getXeroAccounts', companyId);
    dispatch('getSalesItems', companyId);
  },
  async getXeroContacts({ commit }, companyId) {
    try {
      commit(types.SET_XRO_CONTACTS, { contacts: [], companyId, loading: true });
      const apiResponse = await API.xero.getContacts(companyId);
      commit(types.SET_XRO_CONTACTS,
        { contacts: apiResponse.data.contacts, companyId, loading: false });
    } catch (e) {
      console.error(e.message);
      commit(types.SET_XRO_CONTACTS, { contacts: [], companyId, loading: false });
    }
  },
  async getXeroAccounts({ commit }, companyId) {
    try {
      commit(types.SET_XRO_ACCOUNTS, { accounts: [], companyId, loading: true });
      const apiResponse = await API.xero.getAccounts(companyId);
      commit(types.SET_XRO_ACCOUNTS,
        { accounts: apiResponse.data.accounts, companyId, loading: false });
    } catch (e) {
      console.error(e.message);
      commit(types.SET_XRO_ACCOUNTS, { accounts: [], companyId, loading: false });
    }
  },
  async getXeroSalesItems({ commit }, companyId) {
    try {
      commit(types.SET_XRO_SALES_ITEMS, { salesItems: [], companyId, loading: true });
      const apiResponse = await API.xero.getSalesItems(companyId);
      commit(types.SET_XRO_SALES_ITEMS,
        { salesItems: apiResponse.data.items, companyId, loading: false });
    } catch (e) {
      console.error(e.message);
      commit(types.SET_XRO_SALES_ITEMS, { salesItems: [], companyId, loading: false });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};




// WEBPACK FOOTER //
// ./src/store/modules/xero.js